import { useRef } from "react";
import { ApiTaskInvite } from "src/api/types";
import Card from "src/components/Card";
import Avatar from "src/components/Avatar";
import ReadMore from "src/components/ReadMore";
import Button from "src/components/Button";
import { formatPrice } from "src/lib/formatters";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface TaskInviteCardProps {
	invite: ApiTaskInvite;
}

const TaskInviteCard = ({ invite }: TaskInviteCardProps) => {
	const { t } = useTranslation("network", {
		keyPrefix: "task-invite-card",
	});
	const ref = useRef() as any;
	const navigate = useNavigate();
	const task = invite.task;
	const company = task?.company || null;
	return (
		<Card
			{...{ ref }}
			className="cursor-pointer"
			contentClassName="p-8 flex flex-1 relative flex-col gap-2"
			onClick={() => navigate(`/network/${invite.hid}/invite`)}
		>
			{!invite.is_read && (
				<div className="absolute right-8 top-">
					<div className="w-2 h-2 bg-primary rounded-full"></div>
				</div>
			)}
			{company && (
				<div className="flex gap-2 items-end">
					<Avatar
						src={company.avatar}
						alt={company.name}
						size="regular"
					/>
					<strong>{company.name}</strong>
				</div>
			)}
			<span>{moment(invite.created_at).fromNow()}</span>
			<div className="flex gap-1">
				<h2 className="text-primary">
					{formatPrice(task.budget_per_hour || task.budget)}
				</h2>
				{task.budget_per_hour ? (
					<sup className="text-primary font-bold">
						{t("per-hour")}
					</sup>
				) : (
					""
				)}
			</div>
			<div className="flex flex-col flex-1">
				<strong>{task.title}</strong>
				<ReadMore
					className="mb-0"
					text={task.description || ""}
					length={120}
				/>
			</div>
			<Button
				type={invite.is_registered ? "primary" : "orange"}
				to={`/network/${invite.hid}/invite`}
			>
				{invite.is_registered
					? t("button.registered")
					: t("button.view-invite")}
			</Button>
		</Card>
	);
};

export default TaskInviteCard;
